@if (showLabel) {
  <div class="fx--h fx--label fx--label__nowrap fx--label__bold fx--juc-space-between">
    <label class="miq-form-input-label" [attr.for]="filter$().key">{{ filter$().value }}</label>
    @if (showOptionMenuIcon()) {
      <div
        cbre-filter-option
        [compoundFilterConfig]="compoundFilterConfig()"
        [filter]="filter$()"
        [form]="form"
        (filterOptionChange)="filterOptionChange.emit($event)"
      ></div>
    }
  </div>
}
@switch (filter$().inputType) {
  @case ('date') {
    <!-- DATES -->
    <div class="fx--h filters__gap">
      <mat-form-field appearance="outline">
        <input
          matInput
          readonly
          autocomplete="no-autofill"
          [formControl]="fromCtrl"
          [matDatepicker]="fromRangeDatePicker"
          placeholder="FROM"
          (dateChange)="dateEvent('from', $event)"
          [max]="filter$().maxValue"
        />
        <em
          matSuffix
          class="multiselect-clear pi pi-times-circle"
          [class.clear-hidden]="!hasFromCtrlValue()"
          (click)="clearRangeFilter('from', $event)"
        ></em>
        <mat-datepicker-toggle matSuffix [for]="fromRangeDatePicker" class="calendar-toggle"></mat-datepicker-toggle>
        <mat-datepicker #fromRangeDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <input
          matInput
          autocomplete="no-autofill"
          readonly
          [formControl]="toCtrl"
          [matDatepicker]="toRangeDatePicker"
          placeholder="TO"
          (dateChange)="dateEvent('to', $event)"
          [min]="filter$().minValue"
        />
        <em
          matSuffix
          class="multiselect-clear pi pi-times-circle"
          [class.clear-hidden]="!hasToCtrlValue()"
          (click)="clearRangeFilter('to', $event)"
        ></em>
        <mat-datepicker-toggle matSuffix [for]="toRangeDatePicker" class="calendar-toggle"></mat-datepicker-toggle>
        <mat-datepicker #toRangeDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  }

  @case ('number') {
    <!-- For filters with dataType as numeric or integer -->
    <div class="fx--h">
      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          miqOnlyNumbers
          [restrictedKeyCodes]="restrictedKeyCodes"
          [allowedKeyCodes]="allowedKeyCodes"
          [readonly]="fromCtrl?.disabled"
          autocomplete="no-autofill"
          placeholder="FROM"
          [formControl]="fromCtrl"
          [type]="filter$().inputType"
          (keydown.enter)="updateForm($event, 'from')"
        />
        @if (hasFromCtrlValue()) {
          <em class="multiselect-clear pi pi-times-circle" matSuffix (click)="clearRangeFilter('from')"></em>
        }
      </mat-form-field>

      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          miqOnlyNumbers
          [restrictedKeyCodes]="restrictedKeyCodes"
          [allowedKeyCodes]="allowedKeyCodes"
          [readonly]="toCtrl?.disabled"
          [type]="filter$().inputType"
          placeholder="TO"
          autocomplete="no-autofill"
          [formControl]="toCtrl"
        />
        @if (hasToCtrlValue()) {
          <em class="multiselect-clear pi pi-times-circle" matSuffix (click)="clearRangeFilter('to')"></em>
        }
      </mat-form-field>
    </div>
  }

  @default {
    <!-- ALL OTHERS, for example where inputType = text -->
    <div class="fx--h">
      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          [readonly]="fromCtrl?.disabled"
          autocomplete="no-autofill"
          placeholder="FROM"
          [formControl]="fromCtrl"
          [type]="filter$().inputType"
          (keydown.enter)="updateForm($event, 'from')"
        />
        @if (hasFromCtrlValue()) {
          <em class="multiselect-clear pi pi-times-circle" matSuffix (click)="clearRangeFilter('from')"></em>
        }
      </mat-form-field>

      <mat-form-field floatLabel="never" appearance="outline">
        <input
          matInput
          [readonly]="toCtrl?.disabled"
          autocomplete="no-autofill"
          placeholder="TO"
          [formControl]="toCtrl"
          [type]="filter$().inputType"
          (keydown.enter)="updateForm($event, 'to')"
        />
        @if (hasToCtrlValue()) {
          <em class="multiselect-clear pi pi-times-circle" matSuffix (click)="clearRangeFilter('to')"></em>
        }
      </mat-form-field>
    </div>
  }
}
